export class KeyValuePair {
  public key = '';
  public value: any;

  static fromValues(key: string, value: string): KeyValuePair {
    const val = new KeyValuePair();
    val.key = key;
    val.value = value;
    return val;
  }
}
